import React, { Fragment } from "react";
import { Box } from "@atoms";
import { string, shape, arrayOf } from "prop-types";
import isEmpty from "lodash/isEmpty";
import SwitchTeamCampaignList from "./components/SwitchTeamCampaignList";
import SwitchTeamHeader from "./components/SwitchTeamHeader";
import SwitchTeamPersonalItem from "./components/SwitchTeamPersonalItem";
import SwitchTeamPersonalBox from "./components/SwitchTeamPersonalBox";

const SwitchTeam = ({
  activeStatus,
  activeCampaign,
  personalAccount,
  runningCampaigns,
  endedCampaigns,
  firstName,
  lastName,
  photoImage,
  switchTeamUrl,
  personalUserUrl,
  editCampaignUrl,
  userFundsUrl,
  newCampaignUrl,
  campaignMembersUrl,
  joinCampaignUrl,
  rootUrl,
}) => {
  return (
    <div className="switch-team__container">
      <SwitchTeamHeader
        showCheckmark
        activeCampaign={activeCampaign}
        activeStatus={activeStatus}
        campaign={activeCampaign}
        campaignMembersUrl={campaignMembersUrl}
        editCampaignUrl={editCampaignUrl}
        firstName={firstName}
        lastName={lastName}
        personalAccount={personalAccount}
        personalUserUrl={personalUserUrl}
        photoImage={photoImage}
        rootUrl={rootUrl}
        switchTeamUrl={switchTeamUrl}
        title="Header"
        userFundsUrl={userFundsUrl}
      />
      <a href={joinCampaignUrl}>
        <div className="switch-team__row">
          <div className="switch-team__icon color-link">
            <i className="material-icons">add</i>
          </div>
          <div className="d-flex align-items-center color-text">Join Existing Team</div>
        </div>
      </a>
      <a href={newCampaignUrl}>
        <div className="switch-team__row">
          <div className="switch-team__icon color-link">
            <i className="material-icons">add</i>
          </div>
          <div className="d-flex align-items-center color-text">Create New Team</div>
        </div>
      </a>
      {personalAccount.continuityReason === "NEW_USER" ? null : (
        <>
          {isEmpty(runningCampaigns) ? null : (
            <SwitchTeamCampaignList
              activeCampaign={activeCampaign}
              campaigns={runningCampaigns}
              switchTeamUrl={switchTeamUrl}
              title="Running Teams"
            />
          )}
          <SwitchTeamPersonalBox
            activeCampaign={activeCampaign}
            activeStatus={activeStatus}
            firstName={firstName}
            lastName={lastName}
            personalAccount={personalAccount}
            personalUserUrl={personalUserUrl}
            photoImage={photoImage}
            showCheckmark={activeStatus === "PERSONAL"}
            switchTeamUrl={switchTeamUrl}
            title="Personal Account"
          />
          {endedCampaigns.length > 0 ? (
            <SwitchTeamCampaignList
              isClosed
              activeCampaign={activeCampaign}
              campaigns={endedCampaigns}
              switchTeamUrl={switchTeamUrl}
              title="Closed Teams"
            />
          ) : null}
        </>
      )}
    </div>
  );
};

export default SwitchTeam;

SwitchTeam.propTypes = {
  runningCampaigns: arrayOf(shape({})).isRequired,
  activeCampaign: shape({}),
  endedCampaigns: arrayOf(shape({})).isRequired,
  firstName: string.isRequired,
  lastName: string.isRequired,
  photoImage: string,
  personalAccount: shape({}).isRequired,
  activeStatus: string.isRequired,
  switchTeamUrl: string.isRequired,
  personalUserUrl: string.isRequired,
  editCampaignUrl: string.isRequired,
  userFundsUrl: string.isRequired,
  joinCampaignUrl: string.isRequired,
  newCampaignUrl: string.isRequired,
  campaignMembersUrl: string.isRequired,
  rootUrl: string.isRequired,
};

SwitchTeam.defaultProps = {
  activeCampaign: null,
  photoImage: null,
};
